import Rollbar from "rollbar"
import Cookies from "universal-cookie"
import _ from "lodash"

const cookies = new Cookies()

const rollbar = new Rollbar({
	accessToken: "aa8cb54dcb4f49cabcb3c515713f83b7",
	captureUncaught: true,
	captureUnhandledRejections: true,
	payload: {
		environment: ["https://synapse.curefit.co", "https://synapse.alpha.curefit.co"].includes(window.location.origin) ? "production" : "stage",
		user: {
			userId: _.get(cookies.get("userContext"), "email", ""),
			platform: "Synapse UI",
		},
	},
	enabled: import.meta.env.PROD && !["http://localhost:5173", "http://127.0.0.1:5173"].includes(window.location.origin),
	ignoredMessages:["AbortError: signal is aborted without reason"]
})

export class ErrorLogger {
	static info(...args: any[]): void {
		rollbar.info(...args)
	}

	static error(...args: any[]): void {
		rollbar.error(...args)
	}

	static warning(...args: any[]): void {
		rollbar.warning(...args)
	}

	static debug(...args: any[]): void {
		rollbar.debug(...args)
	}

	static configure(options: Rollbar.Configuration): void {
		rollbar.configure(options)
	}
}
